@if (isGlobalScope()) {
    <h3 class="stored-search-title" data-qa="stored-search-title">{{ 'STORED_SEARCHES'|translate }}</h3>
    <ul class="list">
        @for (storedSearchItem of globalStoredSearches; track storedSearchItem.title) {
            <li>
                <button (click)="openDefaultGlobalSearch(storedSearchItem)"
                        [attr.data-qa]="'stored-search-' + storedSearchItem.title"
                        class="button button-list-item list-item">
                    <app-icon [class]="storedSearchItem.iconClass"
                              [iconSize]="AppIconSize.MEDIUM"
                              [svgIcon]="storedSearchItem.svgIcon"
                              class="list-item-icon"/>
                    <span [attr.data-qa]="'stored-search-title-' + storedSearchItem.title|translate" class="list-item-text list-item-title">{{ storedSearchItem.title|translate }}</span>
                </button>
            </li>
        }
    </ul>
} @else if (storedSearchQueries(); as storedSearches) {
    @if (storedSearches.length > 0) {
        <h3 class="stored-search-title" data-qa="stored-search-title">{{ 'STORED_SEARCHES' | translate }}</h3>

        <ul class="list">
            @for (storedSearch of storedSearches; track storedSearch.id) {
                <li>
                    <button (click)="openStoredSearch(storedSearch)"
                            [attr.data-qa]="'stored-search-entry-' + storedSearch.name"
                            class="button button-list-item list-item">
                        <app-icon [iconSize]="AppIconSize.MEDIUM"
                                  [svgIcon]="storedSearch.visibility === SearchQueryVisibilityEnum.PERSONAL ? ICONS.STOREDSEARCH_PERSONAL : ICONS.STOREDSEARCH_PUBLIC"
                                  class="list-item-icon"/>
                        <span [attr.data-qa]="'stored-search-name-' + storedSearch.name" class="list-item-text list-item-title">{{ storedSearch.name }}</span>
                    </button>
                </li>
            }
        </ul>
    }
}
